import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  box-shadow: 10px 22px 44px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background-color: ${props => props.color};
  max-width: 335px;
  width: 100%;
  height: ${props => (props.shrink ? '70px' : '210px')};
  display: flex;
  background-clip: content-box;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-family: PublicSans-Regular;
  font-size: 8px;
  line-height: 10px;
  color: #ffffff;
  letter-spacing: 2px;
  margin-top: 32px;
  text-transform: uppercase;
`;

export const Number = styled.div`
  font-family: PublicSans-Bold;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  letter-spacing: 4px;
  margin-right: 20px;
  margin-top: ${props => (props.shrink ? '' : '40px')};
`;

export const Name = styled.div`
  font-family: PublicSans-Regular;
  font-size: ${props => (props.shrink ? '11px' : '12px')};
  line-height: ${props => (props.shrink ? '13px' : '15px')};
  color: #ffffff;
  letter-spacing: 3px;
  margin-top: ${props => (props.shrink ? '' : 'auto')};
  margin-bottom: ${props => (props.shrink ? '' : '25px')};
  text-transform: uppercase;
`;

export const Icon = styled.img`
  max-height: 35px;
`;

export const SelectedIcon = styled.img`
  cursor: pointer;
  z-index: 1;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  @media (max-width: 500px) {
    z-index: 1;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    right: -12px;
    top: 50%;
    transform: translate(0%, -50%);
    right: -12px;
  }
`;

export const DeleteIcon = styled.img`
  cursor: pointer;
  z-index: 1;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 15px;
  align-items: center;
  margin-bottom: ${props => (props.shrink ? '' : '10px')};
`;

export const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: ${props => (props.shrink ? '' : 'center')};
  margin-left: 22px;
`;

export const IconColumn = styled.div`
  position: absolute;
  right: 10px;
  align-self: flex-end;
  bottom: 10px;
`;